module.exports = __webpack_public_path__ + "img/linkedin.1859b3fd.svg";